function Footer(props) {
    return(
        <div class="footer">
            <div class="footerIcons">
            <a href="mailto:bradley@bradleymather.com"><img class="icon" id="email" src="https://bradleymather.com/wp-content/uploads/2022/07/584856b4e0bb315b0f7675ac.png" alt="email"/></a>
            <a href="https://www.linkedin.com/in/bradleymather/" target="_blank" rel="noreferrer"><img class="icon"src="https://static-exp2.licdn.com/sc/h/akt4ae504epesldzj74dzred8" alt="LinkedIn"/></a>
            <a href="https://github.com/bmather02" target="_blank" rel="noreferrer"><img class="icon" src="https://github.githubassets.com/favicons/favicon-dark.png" alt="GitHub"/></a>
            </div>
            <p>Copyright &copy; Bradley Mather {props.year}</p>
        </div>
    )
}
export default Footer